import { Card, CardHeader, CardContent } from '@/components/ui/card'

export function NationJoinCardSkeleton() {
  return (
    <Card className="flex flex-col">
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between gap-2">
          <div className="bg-muted h-5 w-32 animate-pulse rounded" />
          <div className="bg-muted h-5 w-20 animate-pulse rounded" />
        </div>
        <div className="bg-muted mt-2 h-4 w-28 animate-pulse rounded" />
      </CardHeader>
      <CardContent className="flex flex-1 flex-col justify-between gap-4">
        <div className="bg-muted h-4 w-40 animate-pulse rounded" />
        <div className="bg-muted h-9 w-full animate-pulse rounded" />
      </CardContent>
    </Card>
  )
}
